import {
  GoogleAdsType,
  GoogleAnalyticsType,
  GoogleAnalytics4Type,
  ClevertapAnalyticsType,
  KlaviyoAnalyticsType,
  OmnisendAnalyticsType,
  AisensyAnalyticsType,
  YcloudAnalyticsType,
  LimechatAnalyticsType,
  MoengageAnalyticsType,
  ContloAnalyticsType,
  WebengageAnalyticsType,
  WebhooksType,
  FacebookCombinedAnalyticsType,
  ShipRocketType,
  ShipRocketUIFieldsType,
  EtdProviderConfigItem,
  ShipRocketErrorType,
  ClickPostErrorType,
  ClickPostType,
  ClickPostUIFieldsType,
  RewardsProvider,
  PopCoinsConfig,
  LoyaltyConfig,
  LoyaltyFieldDef,
  iThinkLogisticsType,
  iThinkLogisticsUIFieldsType,
  GoogleTagManagerType,
  ShippingErrorsType,
  ShippingIntegrationConfigType,
  ShippingField,
  ShippingProvider
} from 'src/lib/types/integrations'
import { ChannelConfigType } from 'src/lib/types/channels'
import { validateEmail, validatePincode } from './helpers'
import { MerchantAttributesType } from '../types/merchantAttributes'
import { integrationsConfig } from 'src/assets/SettingsConfig'
import { PaymentMethodConfigType } from '../types/customizeUI'
import { IntegrationsConfig } from '../types/settings'
import { regexPatterns } from './validations'

export const initialIntegrationsChannelConfig: ChannelConfigType[] = [
  {
    id: 'web',
    name: 'Web',
    description: 'Web Flow',
    enabled: true
  }
]

export const initialGoogleAdsAnalyticsState: GoogleAdsType = {
  enabled: false,
  tags: []
}

export const initialGoogleAnalyticsState: GoogleAnalyticsType = {
  enabled: false
}

export const initialGoogleAnalytics4State: GoogleAnalytics4Type = {
  enabled: false,
  measurementId: '',
  apiSecret: '',
  channels: initialIntegrationsChannelConfig
}

export const initialGoogleTagManagerState: GoogleTagManagerType = {
  enabled: false,
  containerId: '',
  channels: initialIntegrationsChannelConfig
}

export const initialClevertapAnalyticsState: ClevertapAnalyticsType = {
  enabled: true,
  accountId: '',
  passcode: '',
  region: '',
  identity: '',
  channels: initialIntegrationsChannelConfig
}
export const initialLimechatAnalyticsState: LimechatAnalyticsType = {
  enabled: false,
  limechat: []
}
export const initialKlaviyoAnalyticsState: KlaviyoAnalyticsType = {
  enabled: false,
  apiKey: '',
  channels: initialIntegrationsChannelConfig
}

export const initialOmnisendAnalyticsState: OmnisendAnalyticsType = {
  enabled: false,
  apiKey: '',
  channels: initialIntegrationsChannelConfig
}

export const initialAisensyAnalyticsState: AisensyAnalyticsType = {
  enabled: false,
  apiKey: '',
  channels: initialIntegrationsChannelConfig
}

export const initialYcloudAnalyticsState: YcloudAnalyticsType = {
  enabled: false,
  apiKey: '',
  channels: initialIntegrationsChannelConfig
}

export const initialMoengageAnalyticsState: MoengageAnalyticsType = {
  enabled: false,
  appId: '',
  dataCenter: '',
  dataAPIId: '',
  dataAPIKey: '',
  channels: initialIntegrationsChannelConfig
}

export const initialWebengageAnalyticsState: WebengageAnalyticsType = {
  enabled: false,
  apiKey: '',
  licenseCode: '',
  isIndiaDatacenter: true,
  channels: initialIntegrationsChannelConfig
}

export const initialContloAnalyticsState: ContloAnalyticsType = {
  apiKey: '',
  enabled: true,
  channels: initialIntegrationsChannelConfig
}

export const initialCombinedFacebookConversionState: FacebookCombinedAnalyticsType = {
  enabled: false,
  pixels: [
    {
      enabled: true,
      pixelId: '',
      conversionsEnabled: false,
      apiToken: '',
      channels: initialIntegrationsChannelConfig
    }
  ]
}

export const initialWebhooksState: WebhooksType = {
  enabled: false,
  webhooks: []
}

export const defaultWebhookEventName = 'checkout_abandoned'

export const intitalLimechatState: LimechatAnalyticsType = {
  enabled: false,
  limechat: []
}
export const defaultShipRocketUIFields: ShipRocketUIFieldsType = {
  enabled: false,
  provider: 'SHIP_ROCKET',
  email: '',
  password: '',
  pickup_pincode: ''
}

export const defaultClickPostUIFields: ClickPostUIFieldsType = {
  enabled: false,
  provider: 'CLICKPOST',
  username: '',
  key: '',
  pickup_pincode: ''
}

export const defaultShipRocketConfig: ShipRocketType = {
  enabled: false,
  provider: 'SHIP_ROCKET',
  email: '',
  password: '',
  pickup_pincode: '',
  shipRocketUIFields: []
}

export const defaultClickPostConfig: ClickPostType = {
  enabled: false,
  provider: 'CLICKPOST',
  username: '',
  key: '',
  pickup_pincode: '',
  clickPostUIFields: []
}

export const defaultIthinkLogisticsConfig: iThinkLogisticsType = {
  enabled: false,
  provider: 'ITHINK_LOGISTICS',
  iThinkLogisticsUIFields: [],
  pickup_pincode: '',
  access_token: '',
  secret_key: ''
}

export const defaultShipRocketErrorState: ShipRocketErrorType = {
  email: { error: '', errorStatus: false },
  pickup_pincode: { error: '', errorStatus: false }
}

export const defaultClickPostErrorState: ClickPostErrorType = {
  pickup_pincode: { error: '', errorStatus: false }
}

export const parseEtdProviderUIConfig = (data: any): EtdProviderConfigItem[] => {
  return data.map((item: any) => ({
    name: item.name,
    label: item.display_name,
    type: item.field_type,
    required: item.required,
    masked: item.masked
  }))
}

export const parseShipRocketConfigForBackend = (data: ShipRocketUIFieldsType) => {
  return {
    external_etd_provider_configuration: {
      enabled: data.enabled,
      provider: data.provider,
      provider_metadata: {
        email: data.email,
        password: data.password,
        pickup_pincode: data.pickup_pincode
      }
    }
  }
}

export const parseClickPostConfigForBackend = (data: ClickPostUIFieldsType) => {
  return {
    external_etd_provider_configuration: {
      enabled: data.enabled,
      provider: data.provider,
      provider_metadata: {
        username: data.username,
        key: data.key,
        pickup_pincode: data.pickup_pincode
      }
    }
  }
}

export const parseIthinkLogisticsConfigForBackend = (data: iThinkLogisticsUIFieldsType) => {
  return {
    external_etd_provider_configuration: {
      enabled: data.enabled,
      provider: data.provider,
      provider_metadata: {
        access_token: data.access_token,
        secret_key: data.secret_key,
        pickup_pincode: data.pickup_pincode
      }
    }
  }
}

export const parseClickPostUIConfig = (data: any): ClickPostUIFieldsType => {
  if (!data) return defaultClickPostUIFields
  return {
    enabled: data.enabled,
    provider: data.provider,
    username: data.username,
    key: data.key,
    pickup_pincode: data.pickup_pincode
  }
}

export const parseShipRocketData = (data: any): ShipRocketUIFieldsType => {
  if (!data || data.provider !== 'SHIP_ROCKET') return defaultShipRocketUIFields
  return {
    enabled: data.enabled,
    provider: data.provider,
    email: data.provider_metadata.email,
    password: data.provider_metadata.password,
    pickup_pincode: data.provider_metadata.pickup_pincode
  }
}

export const parseClickPostData = (data: any): ClickPostUIFieldsType => {
  if (!data || data.provider !== 'CLICKPOST') return defaultClickPostUIFields
  return {
    enabled: data.enabled,
    provider: data.provider,
    username: data.provider_metadata.username,
    key: data.provider_metadata.key,
    pickup_pincode: data.provider_metadata.pickup_pincode
  }
}

export const parseIthinkLogisticsData = (data: any): iThinkLogisticsUIFieldsType => {
  if (!data || data.provider !== 'ITHINK_LOGISTICS') return defaultIthinkLogisticsConfig
  return {
    enabled: data.enabled,
    provider: data.provider,
    access_token: data.provider_metadata.access_token,
    secret_key: data.provider_metadata.secret_key,
    pickup_pincode: data.provider_metadata.pickup_pincode
  }
}

export const parseShipRocketConfig = (data: any): ShipRocketType => {
  const shipRocketData = parseShipRocketData(data[0]?.value?.data?.external_etd_provider_configuration)
  const shipRocketUIConfig = parseEtdProviderUIConfig(data[1]?.value?.data?.field_details)
  return {
    ...shipRocketData,
    shipRocketUIFields: shipRocketUIConfig
  }
}

export const parseSavedShipRocketConfig = (data: any, shipRocketUIConfig: EtdProviderConfigItem[]): ShipRocketType => {
  return {
    ...parseShipRocketData(data?.data?.external_etd_provider_configuration),
    shipRocketUIFields: shipRocketUIConfig
  }
}

export const parseSavedClickPostConfig = (data: any, clickPostUIConfig: EtdProviderConfigItem[]): ClickPostType => {
  return {
    ...parseClickPostData(data?.data?.external_etd_provider_configuration),
    clickPostUIFields: clickPostUIConfig
  }
}

export const parseSaveIthinkLogisticsConfig = (
  data: any,
  iThinkLogisticsUIConfig: EtdProviderConfigItem[]
): iThinkLogisticsType => {
  return {
    ...parseIthinkLogisticsData(data?.data?.external_etd_provider_configuration),
    iThinkLogisticsUIFields: iThinkLogisticsUIConfig
  }
}

export const getInputType = (name: string) => {
  if (name === 'email') return 'email'
  if (name === 'password') return 'password'
  if (name === 'pickup_pincode') return 'number'
  return 'text'
}

export const getCharacterLimit = (name: string) => {
  if (name === 'pickup_pincode') return 6
}

export const handleErrors = (data: ShipRocketUIFieldsType) => {
  const errors = {
    email: { error: '', errorStatus: false },
    password: { error: '', errorStatus: false },
    pickup_pincode: { error: '', errorStatus: false }
  }
  if (!validateEmail(data.email)) {
    errors.email.error = 'Invalid email'
    errors.email.errorStatus = true
  }
  if (data.password.length < 5) {
    errors.password.error = 'Password must be at least 5 characters long'
    errors.password.errorStatus = true
  }
  if (data.pickup_pincode.length !== 6) {
    errors.pickup_pincode.error = 'Invalid pickup pincode'
    errors.pickup_pincode.errorStatus = true
  }
  const hasErrors = Object.values(errors).some(error => error.errorStatus)
  return { errors, hasErrors }
}

export const handleClickPostErrors = (data: ClickPostUIFieldsType) => {
  const errors = {
    username: { error: '', errorStatus: false },
    key: { error: '', errorStatus: false },
    pickup_pincode: { error: '', errorStatus: false }
  }
  if (data.username.length === 0) {
    errors.username.error = 'Username is required.'
    errors.username.errorStatus = true
  }
  if (data.key.length === 0) {
    errors.key.error = 'Invalid key'
    errors.key.errorStatus = true
  }
  if (data.pickup_pincode.length !== 6) {
    errors.pickup_pincode.error = 'Invalid pickup pincode'
    errors.pickup_pincode.errorStatus = true
  }
  const hasErrors = Object.values(errors).some(error => error.errorStatus)
  return { errors, hasErrors }
}

export const handleIthinkLogisticsErrors = (data: iThinkLogisticsUIFieldsType) => {
  const createError = (message = '') => ({
    error: message,
    errorStatus: !!message
  })

  const errors = {
    access_token: createError(!data.access_token.trim() ? 'Access token is required.' : ''),
    secret_key: createError(!data.secret_key.trim() ? 'Secret key is required.' : ''),
    pickup_pincode: createError(!regexPatterns.pincode.test(data.pickup_pincode) ? 'Invalid pickup pincode' : '')
  }

  const hasErrors = Object.values(errors).some(err => err.errorStatus)

  return { errors, hasErrors }
}

export const getMerchantAttributesPayload = (merchant: MerchantAttributesType | null) => {
  return {
    ...merchant,
    attributes: {
      ...merchant?.attributes,
      address_config: {
        ...merchant?.attributes?.addressConfig,
        delivery_config: {
          ...merchant?.attributes?.addressConfig?.deliveryConfig,
          is_etd_enabled: false
        }
      }
    }
  }
}

export const findAndConfigureApps = (apps: any[], configKey: string, typeKey: string, searchText: string) => {
  return apps
    ?.map((app: any) => {
      const matchedApp: any = integrationsConfig?.find((integration: any) => integration[typeKey] === app[configKey])
      if (matchedApp) {
        return {
          ...matchedApp,
          isConfigured: app.is_configured,
          enabled: app.metadata?.enabled,
          permissionId: app.permissionId
        }
      }
      return null
    })
    .filter((app: any) => {
      return app && app.label.toLowerCase().includes(searchText.toLowerCase())
    })
}

export const parseClickPostConfig = (data: any): ClickPostType => {
  return {
    ...parseClickPostData(data[0]?.value?.data?.external_etd_provider_configuration),
    clickPostUIFields: parseEtdProviderUIConfig(data[1]?.value?.data?.field_details)
  }
}

export const parseIthinkLogisticsConfig = (data: any): iThinkLogisticsType => {
  return {
    ...parseIthinkLogisticsData(data[0]?.value?.data?.external_etd_provider_configuration),
    iThinkLogisticsUIFields: parseEtdProviderUIConfig(data[1]?.value?.data?.field_details)
  }
}

export const parseRewardsConfig = (data: any, provider: RewardsProvider): PopCoinsConfig => {
  if (!data) return defaultPopCoinsConfig

  const isMatchingProvider = data?.provider === provider
  return {
    ...defaultPopCoinsConfig,
    loyaltyProvider: isMatchingProvider ? data?.provider : '',
    isActive: isMatchingProvider ? Boolean(data?.active) : false,
    metadata: {
      authToken: data?.provider_metadata?.auth_token ?? ''
    }
  }
}

export const filterRewardsApps = (data: IntegrationsConfig[], rewardsApps: any, searchText: string) => {
  if (!rewardsApps) return []
  return data
    .filter(app => app.category === 'rewards')
    .map(app => {
      const isMatched = rewardsApps?.data?.provider === app.type
      return {
        ...app,
        isConfigured: isMatched && Boolean(rewardsApps?.data?.active),
        enabled: isMatched && Boolean(rewardsApps?.data?.active),
        metadata: {
          authToken: (rewardsApps.data?.provider === app.type && rewardsApps.data?.provider_metadata?.auth_token) || ''
        }
      }
    })
    .filter((app: any) => {
      return app.label.toLowerCase().includes(searchText.toLowerCase())
    })
}

export const defaultPopCoinsConfig: PopCoinsConfig = {
  loyaltyProvider: '',
  metadata: {
    authToken: ''
  },
  isActive: false
}

export const parseRewardsConfigForBackend = (data: PopCoinsConfig, provider: RewardsProvider) => {
  return {
    provider: provider,
    provider_metadata: {
      auth_token: data.metadata.authToken
    },
    active: data.isActive
  }
}

export const handleRewardsConfigErrors = (data: PopCoinsConfig): boolean => {
  return true
}

/**
 * Generic loyalty-config parser for the bespoke connect forms (Yotpo, Nector, CASA, ...).
 * Unlike {@link parseRewardsConfig} (single `auth_token`), this reads an arbitrary set of
 * `fieldKeys` straight out of `provider_metadata` into a flat key→value map.
 */
export const parseLoyaltyConfig = (data: any, provider: RewardsProvider, fieldKeys: string[]): LoyaltyConfig => {
  const isMatchingProvider = data?.provider === provider
  const metadata: Record<string, string> = {}
  fieldKeys.forEach(key => {
    // Nullish (not `||`) so legit falsy values like 0 survive, and String() guarantees a
    // real string — provider_metadata is JSONB/`any`, so a numeric value would otherwise
    // slip through and blow up getMissingLoyaltyFields' `.trim()` at save time.
    const raw = isMatchingProvider ? data?.provider_metadata?.[key] : undefined
    metadata[key] = raw == null ? '' : String(raw)
  })
  return {
    loyaltyProvider: isMatchingProvider ? data?.provider : '',
    isActive: isMatchingProvider ? Boolean(data?.active) : false,
    metadata
  }
}

/** Serializes a {@link LoyaltyConfig} into the rewards-engine PATCH payload. */
export const parseLoyaltyConfigForBackend = (data: LoyaltyConfig, provider: RewardsProvider) => {
  return {
    provider,
    provider_metadata: { ...data.metadata },
    active: data.isActive
  }
}

/** Returns the field keys whose values are blank (used to block save). */
export const getMissingLoyaltyFields = (config: LoyaltyConfig, fields: LoyaltyFieldDef[]): string[] => {
  return fields
    .filter(field => field.isRequired !== false)
    .filter(field => !config.metadata[field.key]?.trim())
    .map(field => field.key)
}

export const parsePaymentModeForRewardsConfig = (loyaltyOrReward: RewardsProvider, status: boolean) => {
  const loyaltyModes = {
    primaryMode: 'LOYALTY',
    secondaryMode: 'REWARDS_WALLET'
  }
  const configs = {
    [RewardsProvider.POP_COINS]: loyaltyModes,
    [RewardsProvider.SHOPFLO]: {
      primaryMode: 'REWARDS_WALLET',
      secondaryMode: 'LOYALTY'
    },
    // All third-party loyalty providers surface a LOYALTY payment mode, same as POPcoins.
    [RewardsProvider.YOTPO]: loyaltyModes,
    [RewardsProvider.RETENZY]: loyaltyModes,
    [RewardsProvider.NECTOR]: loyaltyModes,
    [RewardsProvider.YOUR_TOKEN]: loyaltyModes,
    [RewardsProvider.FLITS]: loyaltyModes,
    [RewardsProvider.CASA]: loyaltyModes,
    [RewardsProvider.REWARD_RALLY]: loyaltyModes,
    [RewardsProvider.E_REWARDS]: loyaltyModes
  }

  const config = configs[loyaltyOrReward]
  if (!config) return

  return {
    modes: status
      ? [
          { mode: config.primaryMode, weight: 1 },
          { mode: config.secondaryMode, weight: 0 }
        ]
      : [{ mode: config.primaryMode, weight: 0 }]
  }
}

export const validateConfig = (config: ShippingIntegrationConfigType) => {
  const errors: ShippingErrorsType = {}
  let hasErrors = false

  config.fields.forEach((field: ShippingField) => {
    const value = config.values[field.name]?.toString().trim() || ''

    if (field.required && !value) {
      errors[field.name] = {
        error: `${field.display_name || field.name} is required`,
        errorStatus: true
      }
      hasErrors = true
      return
    }

    if (field.name.toLowerCase().includes('email') && value && !validateEmail(value)) {
      errors[field.name] = {
        error: 'Invalid email format',
        errorStatus: true
      }
      hasErrors = true
    }

    if (field.name.toLowerCase().includes('pincode') && value && !validatePincode(value)) {
      errors[field.name] = {
        error: 'Pincode must be a 6-digit number',
        errorStatus: true
      }
      hasErrors = true
    }
  })

  return { errors, hasErrors }
}

export const formatConfigForBackend = (config: ShippingIntegrationConfigType) => {
  return {
    external_etd_provider_configuration: {
      enabled: config.enabled,
      provider: config.provider,
      provider_metadata: config.fields.reduce((acc: Record<string, string>, field: ShippingField) => {
        acc[field.name] = config.values[field.name] as string
        return acc
      }, {})
    }
  }
}

export const parseShippingConfig = (
  rawConfig: any,
  uiFields: ShippingField[],
  provider: string
): ShippingIntegrationConfigType => {
  const etdConfig = rawConfig?.external_etd_provider_configuration || {}
  const providerMetadata = etdConfig?.provider_metadata || {}

  if (etdConfig?.provider !== provider) {
    const emptyValues = uiFields.reduce((acc: Record<string, string>, field: ShippingField) => {
      acc[field.name] = ''
      return acc
    }, {})
    return {
      enabled: false,
      provider,
      fields: uiFields,
      values: emptyValues
    }
  }
  return {
    enabled: etdConfig?.enabled ?? false,
    provider: etdConfig?.provider ?? provider,
    fields: uiFields,
    values: uiFields.reduce((acc: Record<string, string>, field: ShippingField) => {
      acc[field.name] = providerMetadata[field.name] ?? ''
      return acc
    }, {})
  }
}

export const mapShippingProvider = (provider: ShippingProvider) => {
  switch (provider) {
    case 'DELHIVERY':
      return 'Delhivery'
    case 'SHIP_DELIGHT':
      return 'Instalogix'
    default:
      return ''
  }
}
